import { render, staticRenderFns } from "./EffarigUnlockButton.vue?vue&type=template&id=7f205610"
import script from "./EffarigUnlockButton.vue?vue&type=script&lang=js"
export * from "./EffarigUnlockButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports